import { useAppSelector } from "redux/hooks";
import { selectClientLens } from "redux/slices/clientLens";

import BreadcrumbDropdownPicker, { type BreadcrumbDropdownPickerOption } from "./BreadcrumbDropdownPicker";
import { AppRoutes } from "AppRoutes";

interface LensSubnavBreadcrumbProps {
  route: "documents" | "exports";
  routeTitle: string;
}

export const FilesSubnavBreadcrumb = (props: LensSubnavBreadcrumbProps) => {
  const clientLens = useAppSelector(selectClientLens);
  const options: BreadcrumbDropdownPickerOption[] = [
    {
      title: "Documents",
      route: AppRoutes.lensFilesBuilder(clientLens.id, "documents"),
      uniqueId: "documents",
    },
    {
      title: "Exports",
      route: AppRoutes.lensFilesBuilder(clientLens.id, "exports"),
      uniqueId: "exports",
    },
  ];

  return (
    <BreadcrumbDropdownPicker
      pendoId="breadcrumb-lens-files::documents/exports"
      search={false}
      label={props.routeTitle}
      noResultsText={undefined}
      currentRoute={AppRoutes.lensFilesBuilder(clientLens.id, props.route)}
      options={options}
    />
  );
};
